import { authService } from '../services/authService';

export type RoleValue = string | number | null | undefined;

export function isAdminRole(role: RoleValue): boolean {
  // Backend currently serializes enum as number (Admin=0), but some places may treat it as string.
  return role === 0 || role === '0' || role === 'Admin';
}

export function isProjectManagerRole(role: RoleValue): boolean {
  return role === 1 || role === '1' || role === 'ProjectManager';
}

export function canManageWbs(role: RoleValue): boolean {
  return isAdminRole(role) || isProjectManagerRole(role);
}

export function roleLabel(role: RoleValue): string {
  if (role === 0 || role === '0' || role === 'Admin') return 'ادمین';
  if (role === 1 || role === '1' || role === 'ProjectManager') return 'مدیر پروژه';
  return 'کاربر';
}

/**
 * Check if user has admin access via legacy role OR RBAC SystemAdmin role
 */
export function isAdminOrHasRBACRole(role: RoleValue): boolean {
  // Legacy admin check
  if (isAdminRole(role)) return true;
  
  // RBAC SystemAdmin check from roles
  const rbacRoles = authService.getUserRoles();
  if (rbacRoles.includes('SystemAdmin')) return true;
  
  return false;
}

/**
 * Check if user has a specific permission via RBAC
 */
export function hasPermission(permission: string): boolean {
  return authService.hasPermission(permission);
}

/**
 * Check if user can manage RBAC (SystemAdmin role or RBAC.Manage permission)
 */
export function canManageRBAC(role: RoleValue): boolean {
  return isAdminOrHasRBACRole(role) || hasPermission('RBAC.Manage');
}